import root from "src/modules/communication-protobuf";
import {
  decodeBase64,
  decodeProtocolBuffer
} from "src/modules/protocol-buffers";
import normalizeEvent from "../../normalizeEvent";

export default function decodePbData(pbData) {
  const buffer = decodeBase64(pbData);
  const data = decodeProtocolBuffer({
    typePath: "comm.ActivityLogSession",
    buffer,
    root
  });
  data.events = data.events.reduce((eventsObject, event) => {
    normalizeEvent(event);
    eventsObject[event.id] = event;
    return eventsObject;
  }, {});
  return data;
}
